
  import { css } from 'lit';
  export const styles = css`:host{--elevation: var(--ig-tooltip-elevation, var(--ig-elevation-9));--background: var(--ig-tooltip-background, hsl(from var(--ig-gray-300) h s l/0.9));--text-color: var(--ig-tooltip-text-color, var(--ig-gray-50-contrast));--ig-theme: indigo;--ig-theme-variant: dark}`;
  